import { createContext } from '@lit/context';
import { BackendFormResponse } from '../util/api';

export const inputResponseContext = createContext<BackendFormResponse>(Symbol('inputResponse'));
